import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  Dialog, DialogContent, Box, Typography, Button,
} from '@mui/material';
import { GppMaybe } from '@mui/icons-material';
import { logout } from '../../store/authSlice';

// Shown when the API returns 403 `organization_suspended` (non-payment lock).
// It blocks the whole app — a suspended org is cut off on every request, login,
// and token refresh — and points the operator at billing/support rather than
// treating it as a normal auth failure.
export default function OrganizationSuspendedScreen() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const organizationSuspended = useSelector((state) => state.auth.organizationSuspended);

  const handleBackToLogin = () => {
    dispatch(logout());
    navigate('/login', { replace: true });
  };

  return (
    <Dialog
      open={organizationSuspended}
      maxWidth="xs"
      fullWidth
      disableEscapeKeyDown
      onClose={() => {}}
      PaperProps={{
        sx: {
          borderRadius: '16px',
          p: 0.5,
          textAlign: 'center',
        },
      }}
    >
      <DialogContent sx={{ px: 4, py: 4 }}>
        {/* Icon */}
        <Box
          sx={{
            width: 64, height: 64, borderRadius: '50%',
            bgcolor: '#FEF2F2',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            mx: 'auto', mb: 2.5,
          }}
        >
          <GppMaybe sx={{ fontSize: 32, color: '#EF4444' }} />
        </Box>

        {/* Title */}
        <Typography sx={{ fontSize: '1.1rem', fontWeight: 800, color: '#1E293B', mb: 1 }}>
          Account Suspended
        </Typography>

        {/* Message */}
        <Typography sx={{ fontSize: '0.85rem', color: '#64748B', lineHeight: 1.6, mb: 3 }}>
          Your organization's account has been suspended and billing is paused.
          Please contact your administrator or support to restore access.
        </Typography>

        {/* CTA */}
        <Button
          fullWidth
          variant="contained"
          onClick={handleBackToLogin}
          disableElevation
          sx={{
            bgcolor: '#4F46E5', color: '#fff',
            py: 1.3, fontSize: '0.9rem', fontWeight: 700,
            borderRadius: '10px', textTransform: 'none',
            '&:hover': { bgcolor: '#4338CA' },
          }}
        >
          Back to Login
        </Button>
      </DialogContent>
    </Dialog>
  );
}
